define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'internal_util/Logger',
	'model/ErrorType',
	'state/UIState',
	'service/UIStateManager',
	'view/ProviderInfoView',
	'view/NavigationView',
	'view/TextView',
	'view/ControlBarView',
	'amdi18n-loader?!state/nls/UIState_strings',
	'amdi18n-loader?!state/nls/IdentitiesRevokationSucceededState_strings'
], function (
	Util,
	UiUtil,
	Logger,
	ErrorType,
	UIState,
	UIStateManager,
	ProviderInfoView,
	NavigationView,
	TextView,
	ControlBarView,
	CommonStrings,
	Strings
) {
	'use strict';

	/**
	 * IdentitiesRevokationSucceededState class
	 */
	function IdentitiesRevokationSucceededState(uiStateManager) {
		var _uiStateManager,
			_providerInfoView = new ProviderInfoView(),
			_navigationView = new NavigationView(),
			_textView = new TextView(),
			_controlBarView = new ControlBarView('skIdS_control-bar-identities-revokation-succeeded');

		if (uiStateManager instanceof UIStateManager) {
			_uiStateManager = uiStateManager;
		} else {
			throw new Error('no valid uiStateManager found');
		}

		_navigationView.update(Strings.cloud_identitites_revokation_successful);

		_textView.get().addClass('skIdS_identities-revokation-succeeded-information skIdS_content-body');
		_textView.addText(Strings.message_text_1);
		_textView.addNewLine(1);
		_textView.addText(Strings.message_text_2, function () {
			_uiStateManager.change('identity_creation');
		})

		_controlBarView.addButton(CommonStrings.back, function () {
			_uiStateManager.change('identities_overview');
		}, 0);

		_controlBarView.addButton(CommonStrings.abort, function () {
			_uiStateManager.abort();
		});

		UIState.call(this, 'identities_revokation_succeeded');


		// public methods

		this.title = function () {
			return _uiStateManager.core().cloudIdentitiesManager().providerInfo().description();
		};
		
		this.poweredByImage = function () {
			if (_uiStateManager.core().optionsManager() === null || _uiStateManager.core().optionsManager() === undefined) {
				return null;
			}
			return _uiStateManager.core().optionsManager().providerInfo().poweredByImage();
		};

		this.content = function () {
			return [ _providerInfoView, _navigationView, _textView ];
		};

		this.controls = function () {
			return _controlBarView;
		};

		this.enter = function (doneCallback) {
			_providerInfoView.update(_uiStateManager.core().cloudIdentitiesManager().providerInfo());

			Util.callCallbacks(doneCallback);

			UiUtil.scrollTo(_navigationView);
		};

		this.leave = function (doneCallback) {
			Util.callCallbacks(doneCallback);
		};
	};

	IdentitiesRevokationSucceededState.prototype = Object.create(UIState.prototype);

	return IdentitiesRevokationSucceededState;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/state/IdentitiesRevokationSucceededState.js
// module id = 346
// module chunks = 2